import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Heading, useResponsive } from '@common-fe/common-fe';

import { Roles } from '@/common/constants';
import { useHasAccess } from '@/modules/core/hooks';
import { ChangeStatusCardModal } from '@/modules/transaction/components/Cards/components/ChangeStatusCardModal/ChangeStatusCardModal';
import { useAuthStore } from '@/modules/user/stores';

import { useGetCardsQuery } from '../../queries/useGetCards.query';

import { AddCardDependentModal } from './components/AddCardDependentModal/AddCardDependentModal';
import { CardActivationModal } from './components/CardActivationModals/CardActivationModal';
import { CardsSection } from './components/CardsSection';
import { EmptyCardListPlaceholder } from './components/EmptyCardListPlaceholder';

export const Cards = () => {
  const { t } = useTranslation();
  const { user } = useAuthStore();
  const { cardMap, isLoading } = useGetCardsQuery(user?.employee?.id);
  const isBlockedCardAddition = useHasAccess([
    {
      role: Roles.employeeLimitedAccess,
    },
  ]);
  const { isMobile } = useResponsive();
  return (
    <Box>
      <Box
        margin={{ bottom: 'spacing24', horizontal: isMobile ? 'spacing16' : '' }}
        direction="row"
        justify="between"
        align="center"
      >
        <Heading data-testid="Cards_title" level={1} color="textTitle" size="regular">
          {t('Cards')}
        </Heading>

        <AddCardDependentModal isLimitedAccess={isBlockedCardAddition} />
      </Box>

      {Object.keys(cardMap).length ? (
        Object.keys(cardMap).map((holderName) => (
          <CardsSection
            key={holderName}
            cardsByStatus={cardMap[holderName]}
            holderName={holderName}
            isLoading={isLoading}
          />
        ))
      ) : (
        <EmptyCardListPlaceholder />
      )}

      <ChangeStatusCardModal />
      <CardActivationModal />
    </Box>
  );
};
